import { Link } from "react-router-dom";

/**
 * RockLadder brand mark. Serves the user's byte-exact original logo via
 * <picture> — AVIF for browsers that support it, PNG fallback for everyone else.
 *
 * Variants:
 *  - "full" (default): the primary horizontal logo used in header + footer
 *  - "icon":           square icon-only crop, used in 404 + compact spots
 */
export default function Brand({
  variant = "full",
  className = "",
  imgClassName = "",
  "data-testid": testId = "brand-logo",
  height,
  to = "/",
  as = "link",
  light = false,
}) {
  const alt = "RockLadder Technologies";
  const style = height ? { height: `${height}px`, width: "auto" } : undefined;

  const isIcon = variant === "icon";
  const png = isIcon ? "/brand/rockladder-logo-icon.png" : "/brand/rockladder-logo.png";
  const avif = isIcon ? null : "/brand/rockladder-logo.avif";

  const inner = (
    <picture>
      {avif && <source srcSet={avif} type="image/avif" />}
      <img
        src={png}
        alt={alt}
        className={[
          "select-none pointer-events-none block",
          light ? "" : "drop-shadow-[0_0_14px_rgba(255,255,255,0.06)]",
          imgClassName,
        ].join(" ")}
        style={style}
        draggable="false"
        loading="eager"
        decoding="async"
      />
    </picture>
  );

  if (as === "img") return inner;

  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex items-center select-none ${className}`}
      aria-label="RockLadder Technologies — Home"
    >
      {inner}
    </Link>
  );
}
